import { useState, useEffect } from "react"
import { useApolloClient, useQuery } from "@apollo/client"
import { EledoAccountMember, EledoUserMembershipsData, EledoUserMembershipsVars, GET_USER_MEMBERSHIPS } from "graphql/EledoAccountMemberQueries"


function useEledoUserMemberships({limit, page}: EledoUserMembershipsVars) {
  const client = useApolloClient()
  const { loading, error, data } = useQuery<EledoUserMembershipsData, EledoUserMembershipsVars>(GET_USER_MEMBERSHIPS, {variables:{limit, page}})
  const [memberships, setEledoUserMemberships] = useState<EledoAccountMember[]>([])
  const [total, setTotal] = useState<number>(0)
  const [membershipsLoading, setEledoUserMembershipsLoading] = useState<boolean>(false)

  useEffect(() => {
    if (loading){
      setEledoUserMembershipsLoading(true)
      return
    }

    const _members: EledoAccountMember[] = data?.userMemberships.items.map(log => structuredClone(log)) || []

    setEledoUserMemberships(_members)
    setTotal(data?.userMemberships.total || 0)
    setEledoUserMembershipsLoading(loading)
  }, [data, client, loading])

  return { membershipsLoading, error, memberships, total }
}


export default useEledoUserMemberships